import { useTranslation } from 'react-i18next';

export type VideoType = {
  contentful_id: string;
  title: string;
  file: {
    url: string;
    contentType: `video/${string}`;
    details: {
      image: null;
    };
  };
};

export type VideoElementAttributes = JSX.IntrinsicElements['video'];

export type VideoComponentProps = {
  video: VideoType;
  backgroundColor?: string;
};

export const Video: React.FC<VideoElementAttributes & VideoComponentProps> = ({ video, backgroundColor, ...props }) => {
  const { t } = useTranslation(['common']);

  return (
    <video {...props} style={{ backgroundColor }} autoPlay={true} loop={true}>
      <source src={video.file.url} type={video.file.contentType} />
      {t('common:browser_does_not_support_video')}
    </video>
  );
};
